export default {
  common: {
    accept: 'Aceptar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    copy: 'Copiar',
    retry: 'Reintentar',
    loading: 'Cargando…',
    search: 'Buscar',
    confirm: 'Confirmar',
    yes: 'Sí',
    no: 'No',
    back: 'Volver',
    none: 'Ninguno',
    all: 'Todos',
    clear: 'Limpiar',
    refresh: 'Actualizar',
    prev: 'Anterior',
    next: 'Siguiente',
    sending: 'Enviando…',
  },
  nav: {
    library: 'Biblioteca',
    import: 'Importar',
    cloud: 'En la nube',
    settings: 'Ajustes',
    stats: 'Estadísticas',
    knowledge: 'Conocimiento',
    review: 'Repaso',
    discover: 'Descubrir',
    clubs: 'Clubs',
    account: 'Cuenta',
    notifications: 'Notificaciones',
    skipToContent: 'Saltar al contenido',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    search: 'Buscar',
  },
  import: {
    title: 'Importar libros',
    subtitle: 'Añade EPUBs a tu biblioteca. Los archivos se guardan solo en este navegador.',
    dropTitle: 'Arrastra tus EPUBs aquí',
    dropHint: 'o haz clic para elegir archivos · puedes importar varios a la vez',
    lastReport: 'Última importación',
    reportImported: '{count} libro(s) importado(s) | {count} libro importado | {count} libros importados',
    reportSkipped: '{count} duplicado(s) saltado(s) | {count} duplicado saltado | {count} duplicados saltados',
    reportFailed: '{count} con error | {count} con error | {count} con error',
    goToLibrary: 'Ir a la biblioteca',
    helpTitle: 'Consejos',
    help1: 'Puedes importar varios EPUB a la vez arrastrándolos o seleccionándolos.',
    help2: 'Si un archivo ya está en tu biblioteca (mismo contenido), se omite automáticamente.',
    help3: 'Los archivos no se suben a ningún servidor; viven en el almacenamiento local del navegador.',
  },
  shelves: {
    manage: 'Gestionar estanterías',
    manageHide: 'Ocultar gestión',
    createButton: 'Crear',
    createPlaceholder: 'Nombre de la estantería…',
    descriptionPlaceholder: 'Descripción opcional…',
    pickColor: 'Elegir color',
    noColor: 'Sin color',
    bookCount: '{count} libro(s) | {count} libro | {count} libros',
    created: 'Estantería «{name}» creada.',
    updated: 'Estantería actualizada.',
    deleted: 'Estantería «{name}» eliminada.',
    empty: 'Aún no hay estanterías. Crea la primera arriba.',
    addToShelf: 'Añadir a estantería',
    inShelves: 'En estanterías',
    none: 'Ninguna',
    organize: {
      button: 'Organizar por metadatos',
      title: 'Organizar por metadatos',
      intro: 'Crea estanterías automáticamente agrupando tus libros por un campo.',
      field: 'Agrupar por',
      'field.author': 'Autor',
      'field.publisher': 'Editorial',
      'field.language': 'Idioma',
      'field.collection': 'Serie',
      mode: 'Si ya existe una estantería con ese nombre',
      'mode.merge': 'Combinar (añadir sin quitar)',
      'mode.replace': 'Reemplazar (vaciar y rellenar)',
      preview: 'Vista previa',
      previewSummary:
        'Se {created, plural, =0 {crearán} one {creará} other {crearán}} {created} {created, plural, one {estantería nueva} other {estanterías nuevas}}, se {updated, plural, =0 {actualizarán} one {actualizará} other {actualizarán}} {updated} {updated, plural, one {existente} other {existentes}} y se omitirán {skipped} {skipped, plural, one {libro sin valor} other {libros sin valor}}.',
      emptyGroups: 'No hay grupos con los libros y campo actuales.',
      apply: 'Aplicar',
      applying: 'Aplicando…',
      cancel: 'Cancelar',
      result:
        'Se {created, plural, =0 {crearon} one {creó} other {crearon}} {created} {created, plural, one {estantería} other {estanterías}}, se {updated, plural, =0 {actualizaron} one {actualizó} other {actualizaron}} {updated}.',
    },
    reextract: {
      button: 'Generar etiquetas desde los EPUB',
      confirmTitle: 'Generar etiquetas desde los EPUB',
      confirmMessage:
        'Relee cada EPUB y añade sus géneros (<dc:subject>) a las etiquetas, sin sobrescribir las que ya tengas. Solo procesa libros con archivo local. Puede tardar un poco en librerías grandes.',
      apply: 'Generar',
      applying: 'Generando…',
      result:
        'Etiquetas actualizadas en {updated} {updated, plural, one {libro} other {libros}}, {unchanged} sin cambios, {missing} sin archivo local y {failed} {failed, plural, one {fallo} other {fallos}}.',
    },
  },
  cloud: {
    title: 'En la nube',
    subtitle: '{count} libro(s) en la nube | {count} libro en la nube | {count} libros en la nube',
    searchPlaceholder: 'Buscar por título o autor…',
    hideLocal: 'Ocultar los ya en este dispositivo',
    refresh: 'Actualizar',
    extractCovers: 'Rescatar portadas',
    extractCoversHint: 'Extraer las portadas de los libros que no la tienen (procesa en el servidor)',
    extractCoversStarting: 'Rescatando portadas en la nube…',
    extractCoversRunning: 'Rescatando…',
    extractCoversDone: '{n} portada(s) rescatada(s).',
    extractCoversPartial: 'Rescatadas {ok}, fallaron {fail}.',
    extractCoversFailed: 'No se pudo rescatar ninguna portada.',
    extractCoversNothing: 'Todas las portadas ya estaban presentes.',
    loading: 'Cargando biblioteca de la nube…',
    empty: 'No tienes libros en la nube todavía.\nSube uno desde el detalle de un libro para verlo aquí en otros dispositivos.',
    emptyFiltered: 'No hay libros que coincidan con la búsqueda o el filtro.',
    onDevice: 'En este dispositivo',
    downloading: 'Bajando…',
    download: 'Descargar',
    // Acción principal: abre el libro para leer al instante (descarga
    // transparente en background). Es el nuevo flujo por defecto.
    read: 'Leer',
    opening: 'Abriendo…',
    // "Guardar offline" explícito: baja el libro sin abrirlo, para tenerlo
    // disponible sin conexión (p. ej. un viaje en avión).
    saveOffline: 'Guardar offline',
    savingOffline: 'Guardando…',
    prev: 'Anterior',
    next: 'Siguiente',
    pageOf: 'Página {page} de {total}',
    signInPrompt: 'Inicia sesión y activa la sincronización para ver tus libros en la nube.',
    goToAuth: 'Iniciar sesión',
    goToSettings: 'Ir a Ajustes',
    uploadAll: 'Subir toda la local',
    uploadAllHint: 'Subir {n} libro(s) de tu biblioteca a la nube',
    uploadFiles: 'Subir archivos',
    uploadNothing: 'No hay libros locales pendientes de subir.',
    uploadStarting: 'Subiendo {n} libro(s) a la nube…',
    uploadingItem: 'Subiendo {current} de {total}',
    uploadFinished: 'Subida completada',
    uploadAllDone: '{n} libro(s) subido(s) a la nube.',
    uploadPartial: 'Subidos {ok}, fallaron {fail}. Revisa el detalle.',
    uploadFailed: 'No se pudo subir ningún libro.',
    uploadAlreadyRunning: 'Ya hay una subida en curso.',
    deleteFromCloud: 'Eliminar de la nube',
    deleteConfirm: '¿Eliminar «{title}» de la nube?\n\nLa copia local en este dispositivo no se borrará.',
    deleted: 'Libro eliminado de la nube.',
    fileTooLarge: 'El archivo pesa {size} MB. El límite por archivo en la nube es 50 MB.',
    // Modo selección (borrado en lote de la nube)
    selectMode: 'Seleccionar',
    exitSelection: 'Salir',
    selectAll: 'Seleccionar todo',
    clearSelection: 'Limpiar',
    cancelSelection: 'Cancelar',
    selectedCount: '{n} seleccionado(s)',
    deleteSelected: 'Eliminar',
    deleteSelectedConfirm:
      '¿Eliminar {n} libro(s) de la nube?\n\nLas copias locales en tus dispositivos no se borrarán. Solo se quitarán de la nube.',
    deletedMany: '{n} libro(s) eliminado(s) de la nube.',
    deletePartial: 'Se eliminaron {ok}, fallaron {fail}. Revisa la lista.',
    deleteFailed: 'No se pudo eliminar ningún libro de la nube.',
  },
  search: {
    title: 'Buscar en la biblioteca',
    placeholder: 'Busca en el contenido de tus libros y anotaciones…',
    searching: 'Buscando…',
    noResults: 'Sin resultados.',
    resultsCount: '{count} resultado(s) | {count} resultado | {count} resultados',
    groupBook: 'Libro',
    groupHighlight: 'Anotación',
    openInReader: 'Abrir en el lector',
    chapter: 'Capítulo',
    annotation: 'Anotación',
    shortcutHint: 'Pulsa Ctrl/⌘+K para buscar',
    indexingBooks: 'Indexando biblioteca…',
    migrationProgress: 'Indexando {done} de {total} libros…',
    migrationDone: 'Biblioteca indexada.',
    openButton: 'Buscar en el contenido',
  },
  knowledge: {
    title: 'Conocimiento',
    subtitle: 'Tus anotaciones agrupadas en temas y conectadas entre sí.',
    themesCount: '{count} tema(s) | {count} tema | {count} temas',
    memberCount: '{count} anotación(es) | {count} anotación | {count} anotaciones',
    analyzing: 'Analizando tus anotaciones…',
    empty: 'Aún no hay temas. Crea más anotaciones para que aparezcan conexiones.',
    noEmbeddings: 'Para generar temas y conexiones semánticas necesitas un proveedor de embeddings (OpenAI u Ollama).',
    embeddingNeeded: 'Ir a Ajustes',
    backlinks: 'Te enlazan',
    related: 'Relacionados',
    relatedEmpty: 'Buscando relacionados…',
    connections: 'Conexiones',
    aliasNotFound: 'No se encontró ninguna nota para «{alias}».',
    wikiHint: 'Escribe [[alias]] en tus notas para enlazarlas entre sí.',
  },
  rag: {
    askBook: 'Preguntar al libro',
    askLibrary: 'Preguntar a la biblioteca',
    placeholder: 'Pregunta sobre el contenido…',
    thinking: 'Pensando…',
    cited: 'Respuestas fundadas con citas',
    jumpToCitation: 'Ir al pasaje citado',
    jumpFailed: 'No se pudo ir a la cita: {reason}',
    bookNotFound: 'El libro citado ya no está en la biblioteca.',
    noAnswer: 'No encontré información sobre eso en el contexto.',
    needsEmbeddings: 'Esta función requiere un proveedor de embeddings (OpenAI u Ollama) en Ajustes → IA.',
    crossSummary: 'Resumen cruzado',
    selectBook1: 'Libro 1',
    selectBook2: 'Libro 2',
    topic: 'Tema a comparar',
    topicPlaceholder: 'p. ej. atención, memoria, libertad…',
    generate: 'Generar',
    crossUserPrompt: 'Compara cómo tratan estos dos libros el tema indicado.',
    crossFailed: 'No se pudo generar el resumen cruzado: {reason}',
  },
  librarian: {
    badge: 'Bibliotecario',
    intro: 'Soy El Bibliotecario. Pregúntame recomendaciones: «¿qué leo después de terminar X?», «algo corto de ciencia ficción», «parecido a Y»…',
  },
  review: {
    title: 'Repaso',
    subtitle: 'Repasa tus anotaciones con repetición espaciada para retenerlas.',
    empty: 'Aún no tienes tarjetas de repaso.',
    emptyHint: 'Abre un libro, marca un texto y pulsa el botón de repaso (⏰) en sus anotaciones.',
    start: 'Empezar repaso',
    queue: 'Cola',
    ofN: 'de {total}',
    done: 'repasadas',
    completed: '¡Sesión completada!',
    showAnswer: 'Mostrar respuesta',
    again: 'Otra vez',
    hard: 'Difícil',
    good: 'Bien',
    easy: 'Fácil',
    dueToday: 'vencidas hoy',
    filters: 'Filtros',
    allBooks: 'Todos los libros',
    allColors: 'Todos los colores',
    onlyDue: 'Solo vencidas',
    addToReview: 'Añadir al repaso',
    removeFromReview: 'Quitar del repaso',
    generateQuestion: 'Generar pregunta',
    questionReady: 'Pregunta lista',
    noCards: 'No hay tarjetas con esos filtros.',
  },
  share: {
    title: 'Lectura compartida',
    createLink: 'Crear enlace de lectura',
    createFailed: 'No se pudo crear el enlace compartido.',
    linkCopied: 'Enlace copiado al portapapeles. Compártelo con tu club de lectura.',
    hint: 'Quien abra el enlace verá las anotaciones de este libro en tiempo real y podrá descargarlo.',
    accepting: 'Aceptando invitación…',
    downloading: 'Descargando libro compartido…',
    inviteAccepted: 'Te has unido a la lectura compartida.',
    inviteAcceptedHint: 'El libro se ha añadido a tu biblioteca. Ábrelo para ver y añadir anotaciones conjuntas.',
    inviteFailed: 'No se pudo unir a la lectura. El enlace puede haber expirado.',
    missingShare: 'Falta el identificador de la invitación en el enlace.',
    redirecting: 'Llevándote a tu biblioteca…',
    retry: 'Reintentar',
    goToLibrary: 'Ir a la biblioteca',
    memberHint: 'Este libro lo recibiste por invitación. Las anotaciones se sincronizan en tiempo real con quien te lo compartió.',
    leaveShare: 'Salir del libro compartido',
    leaveShareConfirmBody: '¿Salir de este libro compartido? Se eliminará de tu biblioteca. Puedes volver a unirte con el enlace de invitación.',
    leaveDone: 'Has salido del libro compartido.',
    leaveFailed: 'No se pudo salir del libro compartido. Inténtalo de nuevo.',
    roles: { owner: 'Owner', annotator: 'Anotador', viewer: 'Lector' },
    viewerHint: 'Estás en modo sólo lectura. No puedes añadir anotaciones ni comentarios.',
    inviteByEmail: 'O invitar por email',
    emailPlaceholder: "amigo{'@'}dominio.com",
    sendInvite: 'Enviar invitación',
    inviteSent: 'Invitación enviada a {email}.',
  },
  discover: {
    title: 'Descubrir',
    subtitle: 'Citas que otros lectores han compartido públicamente.',
    empty: 'Aún no hay citas públicas. Comparte alguna desde tus anotaciones.',
    loadMore: 'Cargar más',
    noMore: 'No hay más citas.',
    scopeGlobal: 'Global',
    scopeFollowing: 'Siguiendo',
    sortRecent: 'Recientes',
    sortTop: 'Top',
    report: 'Reportar',
    reported: 'Reportado. Gracias.',
    reportFailed: 'No se pudo reportar.',
    reportPlaceholder: '¿Por qué lo reportas?',
    sendReport: 'Enviar reporte',
    publishAction: 'Publicar en Descubrir',
    published: 'Publicado en Descubrir (click para quitar)',
    publishedToast: 'Cita publicada en Descubrir.',
    unpublished: 'Cita quitada del feed público.',
    publishFailed: 'No se pudo publicar la cita.',
  },
  library: {
    title: 'Biblioteca',
    heroEyebrow: 'Tu rincón de lectura',
    import: 'Importar',
    importHint: 'Arrastra archivos EPUB aquí o haz clic para seleccionar',
    imported: '{count} libro(s) importado(s) | {count} libro importado | {count} libros importados',
    importFailed: 'No se pudo importar "{name}": {reason}',
    deleted: 'Libro eliminado de la biblioteca',
    empty: 'Tu biblioteca está vacía. Importa un EPUB para empezar.',
    searchPlaceholder: 'Buscar por título o autor…',
    filterAll: 'Todos',
    filterUnread: 'No leídos',
    filterReading: 'Leyendo',
    filterFinished: 'Leídos',
    sortByRecent: 'Recientes',
    sortByTitle: 'Título',
    sortByAuthor: 'Autor',
    sortByProgress: 'Progreso',
    cover: 'Portada',
    open: 'Abrir',
    importing: 'Importando libros…',
    loadingLibrary: 'Cargando biblioteca…',
    allTags: 'Todas',
    allShelves: 'Todas',
    noMatches: 'No hay libros que coincidan con los filtros actuales.',
    bookCount: '{count} libro(s) en total | {count} libro en total | {count} libros en total',
    errorLabel: 'Error: {message}',
    continueReading: 'Continúa leyendo',
    continueButton: 'Continuar',
    sectionReading: 'Leyendo',
    sectionNotStarted: 'Sin empezar',
    sectionRecentlyFinished: 'Terminados recientemente',
    sectionFavorites: 'Favoritos',
    sectionAll: 'Tu colección',
    sectionResults: 'Resultados',
    sectionCloud: 'En la nube',
    sectionCloudHint: 'Libros tuyos que no están en este dispositivo',
    viewAllCloud: 'Ver toda la nube',
    alsoInCloud: 'Disponible en la nube',
    cloudOnly: 'Solo en la nube',
    viewCloudManagement: 'Gestionar en la nube',
    loadMore: 'Cargar más',
    density: 'Densidad de la rejilla',
    density_compact: 'Compacto',
    density_comfortable: 'Cómodo',
    density_list: 'Lista',
    importSkipped: '«{name}» ya está en tu biblioteca como «{existing}». Se ha omitido.',
    deleteBook: 'Eliminar de la biblioteca',
    favorite: 'Marcar como favorito',
    unfavorite: 'Quitar de favoritos',
    addedToFavorites: 'Añadido a favoritos',
    favorites: 'Favoritos',
    favoritesHint: 'Ver solo tus libros favoritos',
    removedFromFavorites: 'Quitado de favoritos',
    sharedChip: 'Compartidos',
    sharedBadge: 'Libro compartido',
    uploadToCloud: 'Subir a la nube',
    uploadedToCloud: 'Subido a la nube',
    alreadyInCloud: 'Ya en la nube',
    addToShelf: 'Añadir a estantería',
    shelvesEmpty: 'No tienes estanterías. Créalas en Ajustes.',
    // Índice alfabético (A-Z)
    alphaIndex: 'Índice alfabético',
    alphaAll: 'Todas',
    alphaOther: '#',
    alphaModeTitle: 'Títulos',
    alphaModeAuthor: 'Autores',
    // Modo selección (borrado en lote desde la biblioteca)
    selectMode: 'Seleccionar',
    exitSelection: 'Salir',
    selectAll: 'Seleccionar todo',
    clearSelection: 'Limpiar',
    cancelSelection: 'Cancelar',
    selectedCount: '{n} seleccionado(s)',
    deleteSelected: 'Eliminar',
    deleteSelectedConfirm:
      '¿Eliminar {n} libro(s) de tu biblioteca?\n\nEsta acción no se puede deshacer. Se borrarán también sus anotaciones, resúmenes y progreso de lectura.',
    deletedMany: '{n} libro(s) eliminado(s)',
    deleteFromCloudToo: 'Borrar también de la nube ({uploaded} de {total} están subidos)',
  },
  onboarding: {
    title: 'Bienvenido a EPUB Unlimited',
    subtitle: 'Tu rincón de lectura offline-first con anotaciones, IA y sync entre dispositivos. Empieza importando tu primer libro.',
    importEpub: 'Importar EPUB',
    importEpubHint: 'Selecciona uno o varios archivos de tu dispositivo.',
    loadDemo: 'Cargar libro de ejemplo',
    loadDemoHint: 'Descarga «Don Quijote» (dominio público) para probar.',
    demoLoading: 'Descargando…',
    demoSuccess: 'Libro de ejemplo cargado.',
    demoAlready: 'Ya tenías el libro de ejemplo en tu biblioteca.',
    demoError: 'No se pudo descargar el libro de ejemplo. Revisa tu conexión.',
    offlineHint: 'Requiere conexión a internet.',
    configureSync: 'Configurar sync / IA',
    configureSyncHint: 'Activa la sincronización en la nube y/o tu proveedor de IA.',
    importSuccess: '{n} libro(s) importado(s).',
    importSkipped: '{n} duplicado(s) saltado(s).',
    importFailed: '{n} archivo(s) fallaron al importar.',
    dismiss: 'No volver a mostrar',
    showAgain: 'Mostrar guía de inicio',
  },
  bookDetail: {
    author: 'Autor',
    language: 'Idioma',
    publisher: 'Editorial',
    isbn: 'ISBN',
    description: 'Sinopsis',
    tags: 'Etiquetas',
    addTag: 'Añadir etiqueta',
    collection: 'Colección',
    status: 'Estado',
    rating: 'Valoración',
    noRating: 'Sin valorar',
    setRating: 'Valorar con {n} estrella(s) | Valorar con {n} estrella | Valorar con {n} estrellas',
    editMetadata: 'Editar metadatos',
    enrichMetadata: 'Mejorar metadatos',
    enriching: 'Mejorando…',
    enriched: 'Metadatos mejorados: {fields}.',
    enrichFailed: 'No se pudieron mejorar los metadatos: {reason}',
    alreadyComplete: 'Los metadatos ya estaban completos.',
    titleLabel: 'Título',
    authorLabel: 'Autor',
    changeCover: 'Cambiar portada',
    coverNotImage: 'El archivo seleccionado no es una imagen.',
    coverUpdated: 'Portada actualizada.',
    progress: 'Progreso',
    openBook: 'Leer',
    deleteBook: 'Eliminar',
    deleteConfirm: '¿Eliminar este libro? Esta acción no se puede deshacer.',
    toggleSelect: 'Seleccionar o deseleccionar este libro',
    cloud: 'Nube',
    uploadToCloud: 'Subir a la nube',
    uploading: 'Subiendo…',
    uploaded: 'Libro subido a la nube.',
    downloadFromCloud: 'Descargar',
    downloaded: 'Libro descargado de la nube.',
    inCloud: 'En la nube',
    removeFromCloud: 'Eliminar de la nube',
    removeCloudConfirm: '¿Eliminar este libro de la nube?',
    removedFromCloud: 'Libro eliminado de la nube.',
    citation: 'Cita',
    copyCitation: 'Copiar cita',
    citationCopied: 'Cita copiada al portapapeles.',
    uploadFailed: 'No se pudo subir: {reason}',
    downloadFailed: 'No se pudo descargar: {reason}',
    backToLibrary: '← Volver a la biblioteca',
    loading: 'Cargando…',
    bookNotFound: 'No se encontró el libro.',
    continueReading: 'Continuar leyendo',
    startReading: 'Empezar a leer',
    statusLabel: 'Estado:',
    statusUnread: 'Por leer',
    statusReading: 'Leyendo',
    statusFinished: 'Leído',
    details: 'Detalles',
    publisherLabel: 'Editorial:',
    languageLabel: 'Idioma:',
    isbnLabel: 'ISBN:',
    published: 'Publicado:',
    added: 'Añadido:',
    removeTag: 'Quitar etiqueta',
    addPlaceholder: 'Añadir…',
    add: 'Añadir',
    collectionLabel: 'Colección / Serie',
    collectionPlaceholder: 'Ej. Trilogía de la Fundación',
    syncHint: 'Activa la sincronización en Ajustes para subir este libro a la nube y leerlo en otros dispositivos.',
    cloudRemoveFailed: 'No se pudo eliminar: {reason}',
  },
  audio: {
    nowPlaying: 'Escuchando',
    play: 'Reproducir',
    pause: 'Pausa',
    next: 'Siguiente',
    prev: 'Anterior',
    seekBack: 'Retroceder {n} s',
    seekForward: 'Avanzar {n} s',
    seekUnavailable: 'La voz del navegador no puede saltar dentro del audio: cambia a neural',
    stop: 'Cerrar reproductor',
    openInReader: 'Abrir en el lector',
    miniBar: 'Reproductor de audiolibro',
    rate: 'Velocidad',
    sleep: 'Temporizador de sueño',
    sleepOff: 'Sin temporizador',
    sleepMinutes: '{n} min',
    sleepChapter: 'Fin del capítulo',
    engine: 'Voz',
    engineBrowser: 'Navegador (gratis)',
    engineNeural: 'Neural (audiolibro)',
    engineNeuralUnavailable: 'La voz neural requiere OpenAI o una key de ElevenLabs en Ajustes → IA',
    voice: 'Voz neural',
    estimatedCost: 'Coste estimado de este libro: ~{usd} USD',
    browserEngineGone: 'La voz del navegador necesita el lector abierto. Se ha pausado.',
    switchToNeural: 'Cambiar a neural',
    browserEngineGoneNoNeural: 'La voz del navegador necesita el lector abierto. Ábrelo de nuevo para seguir escuchando.',
    backToReader: 'Volver al lector',
    resumeUnavailable: 'No hay voz con la que seguir: abre el lector o cambia a neural',
    cacheTitle: 'Caché de audio',
    cacheHint: 'El audio neural se guarda para no volver a pagarlo. ~1 MB por minuto.',
    cacheLimit: 'Tope del caché (MB)',
    cacheUsed: 'Ocupado: {mb} MB',
    cacheClear: 'Vaciar caché de audio',
    cacheClearConfirm: 'Se borrará todo el audio ya generado de tus libros. Volver a escucharlo lo sintetizará (y cobrará) otra vez.',
    cacheCleared: 'Caché de audio vaciado',
    preparing: 'Preparando el audio…',
    neuralNoText: 'Este libro no tiene texto que la voz neural pueda leer. Se ha vuelto a la voz del navegador.',
    neuralError: 'No se pudo generar el audio: {reason}',
  },
  reader: {
    openingBook: 'Abriendo libro…',
    openError: 'No se pudo abrir el libro.',
    notFound: 'No se encontró el libro.',
    toc: 'Índice',
    tocEmpty: 'Este libro no declara índice.',
    toggleToc: 'Abrir índice',
    searchInBook: 'Buscar en el libro',
    searchResults: '{count} resultados',
    searchEmpty: 'Escribe para buscar en el libro.',
    searchPlaceholder: 'Texto a buscar…',
    searchProgress: 'Buscando…',
    searchEmptyHint: 'Escribe un término y pulsa Buscar.',
    searchClear: 'Limpiar resultados',
    chapter: 'Capítulo',
    pageNext: 'Página siguiente',
    pagePrev: 'Página anterior',
    toolbarMore: 'Más herramientas',
    closeToolbar: 'Cerrar',
    toolbarGroupNav: 'Navegación',
    toolbarGroupContent: 'Contenido',
    toolbarGroupAi: 'Inteligencia artificial',
    toolbarGroupAppearance: 'Apariencia',
    zen: 'Modo Zen',
    exitZen: 'Salir del Modo Zen',
    shortcutsTitle: 'Atajos de teclado',
    shortcuts: {
      nextPage: 'Página siguiente',
      prevPage: 'Página anterior',
      toggleToc: 'Abrir/cerrar índice',
      toggleSearch: 'Abrir/cerrar búsqueda',
      toggleAnnotations: 'Abrir/cerrar anotaciones',
      toggleZen: 'Activar/desactivar Modo Zen',
      toggleShortcuts: 'Mostrar este panel',
      closePopover: 'Cerrar el popover de selección',
    },
    appearance: 'Apariencia y tipografía',
    layout: 'Disposición',
    flowPaginated: 'Paginado',
    flowScrolled: 'Scroll continuo',
    searchAnnotations: 'Buscar en anotaciones…',
    annotationsNoMatches: 'Ninguna anotación coincide con la búsqueda.',
    annotations: 'Anotaciones',
    annotationsEmpty: 'Aún no hay anotaciones en este libro.\nSelecciona texto mientras lees para subrayar.',
    editNote: 'Editar nota',
    deleteAnnotation: 'Eliminar anotación',
    comments: 'Comentarios',
    commentPlaceholder: 'Escribe un comentario…',
    summaries: 'Resúmenes',
    summariesAction: 'Resúmenes con IA',
    viewSummaries: 'Ver resúmenes',
    chatAction: 'Chat sobre el libro',
    openChat: 'Abrir chat contextual',
    bilingual: 'Lectura bilingüe',
    translate: 'Traducir',
    bilingualEmpty: 'Pulsa «Traducir» para ver la sección en dos idiomas.',
    landmarks: 'Índice',
    landmarksEmpty: 'Este libro no declara índice.',
    studyQuestions: 'Preguntas de estudio',
    generateQuestions: 'Generar preguntas',
    studyEmpty: 'Pulsa «Generar preguntas» para obtener preguntas de comprensión del capítulo actual.',
    copyCitation: 'Copiar como cita',
    pomodoro: 'Pomodoro',
    pomodoroFocus: 'Foco',
    pomodoroBreak: 'Descanso',
    pomodoroLongBreak: 'Descanso largo',
    pomodoroStart: 'Empezar',
    pomodoroPause: 'Pausar',
    pomodoroSkip: 'Saltar',
    summarizeHighlights: 'Resumir mis anotaciones',
    noHighlightsToSummarize: 'Aún no hay anotaciones para resumir.',
    translations: 'Traducciones',
    viewTranslations: 'Ver traducciones',
    viewAnnotations: 'Ver anotaciones',
    bookmarks: 'Marcadores',
    bookmarksEmpty: 'Aún no hay marcadores.\nPulsa el icono de marcador en la barra superior para añadir uno.',
    toggleBookmark: 'Marcar/desmarcar página actual',
    addBookmarkHere: 'Marcar página actual',
    viewBookmarks: 'Ver marcadores',
    deleteBookmark: 'Eliminar marcador',
    closeReader: 'Cerrar lectura',
    tts: 'Leer en voz alta',
    ttsPrev: 'Fragmento anterior',
    ttsNext: 'Fragmento siguiente',
    ttsPause: 'Pausar lectura',
    ttsPlay: 'Leer en voz alta',
    ttsStop: 'Detener lectura',
    ttsRate: 'Velocidad',
    ttsRateFull: 'Velocidad de lectura',
    ttsRateShort: 'Vel',
    ttsControls: 'Controles de lectura en voz alta',
    ttsUnsupported: 'Tu navegador no soporta lectura en voz alta.',
    ttsNotSupported: 'Tu navegador no soporta lectura en voz alta.',
    ttsStartFailed: 'No se pudo iniciar la lectura: {reason}',
    colors: {
      yellow: 'Amarillo',
      green: 'Verde',
      blue: 'Azul',
      pink: 'Rosa',
      orange: 'Naranja',
    },
    highlightIn: 'Subrayar en {color}',
    summarizeSelection: 'Resumir selección con IA',
    explainSelection: 'Explicar selección con IA',
    translateSelection: 'Traducir selección',
    bookmarkSelection: 'Marcar posición',
    defineWord: 'Definir palabra',
    addNote: 'Añadir nota',
    selection: {
      highlight: 'Subrayar',
      summarize: 'Resumir',
      explain: 'Explícame',
      translate: 'Traducir',
      bookmark: 'Marcar',
      define: 'Definir',
    },
    annotationAdded: 'Subrayado añadido',
    annotationRemoved: 'Anotación eliminada',
    editAnnotation: 'Editar anotación',
    note: 'Nota',
    notePlaceholder: 'Escribe una nota…',
    noteEdit: 'Editar',
    notePreview: 'Vista previa',
    noteEmpty: 'Nada que previsualizar todavía.',
    color: 'Color',
    bookmarkAdded: 'Marcador añadido',
    bookmarkRemoved: 'Marcador quitado',
    bookmarkLabel: 'Marcador',
    bookmarkNavigateHint: 'Navega a una página para marcarla.',
    exportJson: 'Exportar JSON',
    exportMarkdown: 'Exportar MD',
    exportJsonDone: 'Anotaciones exportadas (JSON)',
    exportMarkdownDone: 'Anotaciones exportadas (Markdown)',
    importJson: 'Importar JSON',
    importDone: '{added} anotaciones importadas',
    importWithSkipped: '{added} importadas, {skipped} ya existían',
    importFailed: 'Importación fallida: {reason}',
    bookmarkFailed: 'No se pudo marcar: {reason}',
    backToLibrary: 'Volver a la biblioteca',
    regenerateError: 'Error: {reason}',
  },
  ai: {
    requiresAuth: 'La IA requiere iniciar sesión',
    requiresAuthHint: 'Inicia sesión con tu cuenta para configurar y usar las funciones de inteligencia artificial.',
    signIn: 'Iniciar sesión',
    summarizing: 'Generando…',
    summarizingWait: 'Esperando respuesta del modelo…',
    summarizeChapter: 'Resumir capítulo',
    summarizeBook: 'Resumir libro',
    summaryDone: 'Resumen generado',
    summaryChapterDone: 'Resumen del capítulo generado',
    summaryBookDone: 'Resumen del libro generado',
    explainDone: 'Explicación generada',
    summaryFailed: 'No se pudo generar el resumen: {reason}',
    summaryHighlightsDone: 'Resumen de tus anotaciones generado',
    explainFailed: 'No se pudo generar la explicación: {reason}',
    summaryEmpty: 'No hay texto en este capítulo para resumir.',
    summaryBookEmpty: 'No hay texto suficiente para resumir el libro.',
    summaryRegenerated: 'Resumen regenerado',
    summaryCopied: 'Resumen copiado al portapapeles',
    copyFailed: 'No se pudo copiar.',
    error: {
      invalidKey: 'La API key no es válida. Revísala en Ajustes → IA.',
      missingKey: 'No hay API key configurada. Añádela en Ajustes → IA.',
      quota: 'Tu cuenta se quedó sin saldo o superó el límite. Revisa tu plan en el proveedor.',
      modelNotFound: 'El modelo configurado no está disponible. Cámbialo en Ajustes → IA.',
      network: 'No se pudo conectar con el proveedor de IA. Comprueba tu conexión.',
    },
    chatTitle: 'Chat sobre el libro',
    chatContextHint: 'Responde según el capítulo actual',
    chatEmpty: 'Haz una pregunta sobre lo que estás leyendo.\nLas respuestas se basan en el capítulo actual.',
    chatPlaceholder: 'Escribe una pregunta…',
    chatSend: 'Enviar',
    chatNoChapter: 'No hay texto de capítulo disponible para contextuar la respuesta.',
    chatFailed: 'No se pudo responder: {reason}',
    summaryPanelEmpty: 'Aún no hay resúmenes.\nSelecciona texto o usa los botones de arriba.',
    translating: 'Traduciendo…',
    translationDone: 'Traducción generada',
    translationFailed: 'No se pudo traducir: {reason}',
    translationCopied: 'Traducción copiada',
    translationPanelEmpty: 'Aún no hay traducciones.\nSelecciona texto y pulsa "Traducir".',
    generatingCancelled: 'Generación cancelada.',
    dictionary: {
      title: 'Definición',
      searching: 'Buscando…',
      consulting: 'Consultando diccionario…',
      notFound: 'No se encontró "{word}" en el diccionario.',
      noResults: 'Sin resultados para "{word}".',
    },
    settings: {
      mode: 'Modo de conexión',
      direct: 'Directo',
      directDesc: 'Tu API key se guarda solo en este navegador.',
      proxy: 'Proxy',
      proxyDesc: 'La key vive en un servidor (más seguro).',
      proxyEndpoint: 'Endpoint del proxy',
      proxyPlaceholder: 'https://tu-worker.workers.dev',
      proxyToken: 'Token del proxy',
      proxyTokenPlaceholder: 'Debe coincidir con APP_TOKEN del Worker',
      activeProvider: 'Proveedor activo',
      tts: 'Voz neural (audiolibro)',
      ttsHint: 'Quién sintetiza el audio de los libros. ElevenLabs usa su propia key y funciona con cualquier proveedor activo.',
      elevenLabsKey: 'API key de ElevenLabs',
      elevenLabsKeyHint: 'Va directa desde este navegador: el modo Proxy solo enruta OpenAI.',
      generation: 'Generación',
      temperature: 'Temperatura (creatividad)',
      temperatureHint: 'Más baja = más fiel al texto; más alta = más libre.',
      summaryLanguage: 'Idioma de los resúmenes',
      syncedToAccount: 'Sincronizada con tu cuenta',
      localOnly: 'Sólo en este dispositivo',
      syncError: 'Error al sincronizar — revisa Diagnóstico',
    },
    usage: {
      title: 'Uso de IA',
      today: 'Hoy',
      month: 'Este mes',
      tokens: 'tokens',
      empty: 'Aún no has usado funciones de IA. Los tokens consumidos aparecerán aquí.',
      localHint: 'Modo offline: mostrando solo la actividad local reciente (sin sincronizar).',
      refreshing: 'Refrescar',
    },
  },
  sync: {
    enabled: 'Sincronización',
    enable: 'Activar sincronización',
    supabaseUrl: 'URL de Supabase',
    supabaseKey: 'Clave anónima (anon key)',
    connected: 'Sincronizado en tiempo real',
    connecting: 'Conectando…',
    saving: 'Guardando en la nube…',
    savingLabel: 'Guardando',
    syncLabel: 'Sync',
    offlineBanner: 'Sin conexión — los cambios se guardan localmente y se sincronizarán al volver.',
    configRequired: 'Falta la configuración de Supabase (defínela en .env.local).',
    envMissing: 'Falta configurar Supabase. Define VITE_SUPABASE_URL y VITE_SUPABASE_PUBLISHABLE_KEY en el archivo .env.local del proyecto y reinicia el servidor de desarrollo.',
    sessionActive: 'Sesión iniciada',
    sessionOk: 'Conexión correcta — sesión activa.',
    sessionOkNoSession: 'Conexión correcta. Inicia sesión para sincronizar.',
    connectionFailed: 'Fallo de conexión: {reason}',
    notSignedIn: 'No has iniciado sesión.',
    signInOrUp: 'Iniciar sesión / Registrarse',
    projectUrl: 'URL del proyecto',
    urlPlaceholder: 'https://xxxx.supabase.co',
    anonKey: 'Anon key',
    anonKeyHint: 'Encuéntrala en Supabase → Settings → API. Es pública (no es un secreto).',
    testing: 'Probando…',
    testConnection: 'Probar conexión',
    syncDescription: 'Al activar la sincronización, tus anotaciones, resúmenes, traducciones y progreso se fusionan automáticamente entre dispositivos (CRDT). Los archivos EPUB se suben bajo demanda.',
    autoUploadOnImport: 'Subir automáticamente a la nube al importar',
    autoUploadOnImportHint: 'Cada EPUB que importes se subirá a la nube en segundo plano (si hay sesión).',
    configured: 'Credenciales configuradas (vía entorno)',
  },
  auth: {
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    signOut: 'Cerrar sesión',
    email: 'Email',
    password: 'Contraseña',
    sessionStarted: 'Sesión iniciada',
    accountCreated: 'Cuenta creada',
    profile: 'Perfil',
    editProfile: 'Editar perfil',
    profileSaved: 'Perfil guardado.',
    avatar: 'Avatar',
    avatarUpdated: 'Avatar actualizado.',
    displayName: 'Nombre público',
    displayNamePlaceholder: 'Tu nombre (visible en el feed y libros compartidos)',
    bio: 'Biografía',
    bioPlaceholder: 'Cuéntale a otros lectores sobre ti…',
    noBio: 'Sin biografía.',
    makePublic: 'Perfil público (visible para otros lectores)',
    publicProfile: 'Perfil público',
    inviteCode: 'Código de invitación',
    inviteCodePlaceholder: 'EPUB-XXXXXX-XXXXXX',
    inviteCodeInvalid: 'Código inválido, expirado o ya usado.',
    inviteCodeValid: 'Código válido.',
    inviteCodeRequired: 'Necesitas un código de invitación válido para registrarte.',
    confirmEmail: 'Revisa tu email para confirmar la cuenta.',
    sessionClosed: 'Sesión cerrada.',
    modeLogin: 'login',
    modeSignup: 'signup',
    haveAccount: '¿Ya tienes cuenta? Inicia sesión',
    noAccount: '¿No tienes cuenta? Regístrate',
    sessionActive: 'Sesión iniciada',
    goToLibrary: 'Ir a la biblioteca',
    createTitle: 'Crear cuenta',
    signinSubtitle: 'Sincroniza tu biblioteca, anotaciones y resúmenes entre dispositivos.',
    emailPlaceholder: "tu{'@'}correo.com",
    passwordPlaceholder: '••••••••',
    processing: 'Procesando…',
    signInShort: 'Entrar',
    signUpShort: 'Registrarme',
    noAccountShort: '¿Sin cuenta?',
    haveAccountShort: '¿Ya tienes cuenta?',
    signUpLink: 'Regístrate',
    signInLink: 'Inicia sesión',
    continueWithoutSync: 'Continuar sin sincronizar',
    memberSince: 'Miembro desde {date}',
    syncActive: 'Sincronización activa',
    syncInactive: 'Sin sincronizar',
    syncStatusHint: 'Tus libros, anotaciones y estanterías se guardan en la nube.',
    syncOffHint: 'Tus datos viven sólo en este dispositivo. Activa la sync en Ajustes para respaldarlos.',
    goToSyncSettings: 'Ajustes de sincronización',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPasswordTitle: 'Recuperar contraseña',
    resetPasswordHint: 'Te enviaremos un correo con instrucciones para restablecerla.',
    resetPasswordSent: 'Revisa tu correo: te enviamos instrucciones para recuperar tu contraseña.',
    resetPasswordCancel: 'Volver',
    sendResetLink: 'Enviar enlace',
    aiLockedTitle: 'Config IA bloqueada',
    aiLockedHint: 'Introduce tu contraseña para sincronizar tu configuración de IA entre dispositivos.',
    unlock: 'Desbloquear',
    unlocking: 'Desbloqueando…',
    unlocked: 'Configuración de IA desbloqueada y sincronizada.',
    confirmPassword: 'Repetir contraseña',
    confirmPasswordPlaceholder: '••••••••',
    passwordMismatch: 'Las contraseñas no coinciden.',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    passwordStrengthWeak: 'débil',
    passwordStrengthFair: 'aceptable',
    passwordStrengthStrong: 'fuerte',
    emailInvalid: 'Email no válido.',
    whatSyncGives: '¿Qué te llevas al sincronizar?',
    syncBenefitLibrary: 'Tu biblioteca en todos tus dispositivos',
    syncBenefitAnnotations: 'Anotaciones y resúmenes siempre disponibles',
    syncBenefitShelves: 'Estanterías y tarjetas de repaso sincronizadas',
    syncBenefitBackup: 'Copia de seguridad automática en la nube',
  },
  stats: {
    title: 'Estadísticas',
    wrappedTitle: 'Tu año {year}',
    wrappedHours: 'Horas de lectura',
    wrappedDays: 'Días leídos',
    wrappedStreak: 'Mayor racha',
    wrappedBooksRead: 'Libros leídos',
    wrappedBooksFinished: 'Libros terminados',
    wrappedHighlights: 'Anotaciones',
    wrappedTopBook: 'Libro más leído',
    wrappedColors: 'Anotaciones por color',
    totalTime: 'Tiempo total',
    currentStreak: 'Racha actual',
    streakDays: 'días',
    reading: 'Leyendo',
    finished: 'Leídos',
    last14Days: 'Últimos 14 días',
    mostRead: 'Más leídos',
    unknown: 'Desconocido',
    empty: 'Aún no hay datos. Abre un libro y empieza a leer para ver tus estadísticas.',
    dailyGoal: 'Meta diaria',
    goalTarget: 'Objetivo',
    goalMinutes: 'min',
    goalMet: '¡Objetivo conseguido! 🎉',
    goalRemaining: 'Te faltan {minutes} min.',
    goalSetHint: 'Fija un objetivo para motivarte.',
    today: 'hoy',
  },
  settings: {
    title: 'Ajustes',
    appearance: 'Apariencia',
    theme: 'Tema',
    themeDark: 'Oscuro',
    themeLight: 'Claro',
    themeSepia: 'Sepia',
    highlightColors: 'Colores de subrayado',
    appMode: 'Modo de la app',
    appModeHint: 'Aspecto de la interfaz. Independiente del tema del lector.',
    modeLight: 'Claro',
    modeDark: 'Oscuro',
    modeSystem: 'Sistema',
    language: 'Idioma',
    typography: 'Tipografía',
    fontFamily: 'Fuente',
    fontSize: 'Tamaño',
    lineHeight: 'Interlineado',
    margin: 'Margen',
    letterSpacing: 'Espaciado de letras',
    wordSpacing: 'Espaciado de palabras',
    paragraphSpacing: 'Espaciado de párrafos',
    accessibility: 'Accesibilidad',
    dyslexicFont: 'Fuente OpenDyslexic',
    bionicReading: 'Lectura biónica',
    bionicWarning: 'La lectura biónica puede desplazar las anotaciones existentes en esa sección.',
    ttsHighlight: 'Resaltado al leer en voz alta',
    keepScreenAwake: 'Mantener pantalla encendida al leer',
    keepScreenAwakeHint: 'Evita que el protector de pantalla se active mientras lees. Consume más batería.',
    readingGoals: 'Metas de lectura',
    dailyGoal: 'Objetivo diario (min)',
    sync: 'Sincronización',
    ai: 'Inteligencia artificial',
    about: 'Acerca de',
    diagnostics: 'Diagnóstico',
    backup: 'Copia de seguridad',
    backupHint: 'Exporta tu biblioteca completa (libros, anotaciones, progreso) a un archivo .epubu. No incluye tus claves de API ni credenciales.',
    backupExport: 'Exportar biblioteca',
    backupImport: 'Importar biblioteca',
    backupExportDone: 'Biblioteca exportada.',
    backupExportFailed: 'No se pudo exportar: {reason}',
    backupImportDone: 'Importados {books} libro(s) y {annotations} anotación(es). {skipped} duplicado(s) omitido(s).',
    backupImportFailed: 'No se pudo importar: {reason}',
    version: 'Versión',
  },
  pwa: {
    updateAvailable: 'Hay una nueva versión disponible.',
    reload: 'Recargar',
    offlineReady: 'Listo para usar sin conexión.',
  },
  errors: {
    generic: 'Algo salió mal.',
    network: 'Error de red.',
    notFound: 'No encontrado.',
    invalid: 'Inválido.',
    quota: 'Sin espacio de almacenamiento. Libera libros antiguos.',
    bookNotFound: 'No se encontró el libro.',
    openBookFailed: 'No se pudo abrir el libro: {reason}',
    searchFailed: 'Búsqueda fallida: {reason}',
    settingsCorrupt: 'Ajustes corruptos; usando valores por defecto.',
  },
  notif: {
    title: 'Notificaciones',
    empty: 'No tienes notificaciones.',
    markAllRead: 'Marcar todas como leídas',
    generic: 'Tienes una nueva notificación.',
    shareInvited: '{sharer} ha compartido un libro contigo.',
    memberJoined: '{name} se ha unido a un libro compartido.',
    highlightCommented: '{author} ha comentado en una de tus anotaciones.',
    newFollower: '{name} te sigue.',
  },
  profile: {
    anonymous: 'Anónimo',
    notFound: 'Perfil no encontrado o privado.',
    follow: 'Seguir',
    unfollow: 'Dejar de seguir',
    followingToast: 'Ahora sigues a este usuario.',
    unfollowed: 'Has dejado de seguir a este usuario.',
    followers: 'seguidores',
    following: 'siguiendo',
    editOwn: 'Editar',
    placeholder: 'Próximamente: highlights y libros públicos de este lector.',
  },
  clubs: {
    title: 'Clubs de lectura',
    subtitle: 'Lee y debatte en grupo.',
    new: 'Nuevo club',
    create: 'Crear club',
    created: 'Club creado.',
    createFailed: 'No se pudo crear el club.',
    name: 'Nombre',
    description: 'Descripción',
    empty: 'Aún no hay clubs. Crea el primero.',
    join: 'Unirme',
    leave: 'Salir',
    joined: 'Te has unido al club.',
    left: 'Has salido del club.',
    members: 'Miembros',
    membersCount: 'miembros',
    books: 'Libros del club',
    noBooks: 'Aún no hay libros en este club.',
    notFound: 'Club no encontrado.',
  },
  moderation: {
    title: 'Moderación',
    subtitle: 'Revisa reportes y oculta highlights inapropiados.',
    tabReports: 'Reportes',
    tabHidden: 'Ocultos',
    noReports: 'Sin reportes abiertos.',
    noHidden: 'No hay highlights ocultos.',
    resolved: 'Reporte resuelto.',
    dismissed: 'Reporte desestimado.',
    hidden: 'Highlight ocultado.',
    unhidden: 'Highlight visible de nuevo.',
    unhide: 'Mostrar',
  },
  invitations: {
    title: 'Invitaciones',
    subtitle: 'Genera códigos de un solo uso para invitar nuevos usuarios.',
    generate: 'Generar código',
    created: 'Código generado.',
    createFailed: 'No se pudo generar el código.',
    code: 'Código',
    status: 'Estado',
    reservedFor: 'Reservado para',
    usedBy: 'Usado por',
    expires: 'Expira',
    note: 'Nota',
    notePlaceholder: 'Para quién es este código (opcional)',
    revoke: 'Revocar',
    revokeConfirm: '¿Revocar este código? Ya no podrá usarse.',
    revoked: 'Código revocado.',
    copyLink: 'Copiar enlace',
    copyCode: 'Copiar código',
    linkCopied: 'Enlace copiado al portapapeles.',
    codeCopied: 'Código copiado.',
    empty: 'Aún no hay códigos. Genera el primero arriba.',
  },
  admin: {
    title: 'Administración',
    backToApp: 'Volver a la app',
    nav: {
      overview: 'Resumen',
      users: 'Usuarios',
      events: 'Eventos',
      email: 'Email',
      audit: 'Auditoría',
      moderation: 'Moderación',
      invitations: 'Invitaciones',
      system: 'Sistema',
    },
    overview: {
      title: 'Resumen general',
      subtitle: 'Métricas de uso agregadas de toda la aplicación.',
      totalUsers: 'Usuarios totales',
      activeToday: 'Activos hoy',
      active7d: 'Activos 7 días',
      active30d: 'Activos 30 días',
      newUsers30d: 'Nuevos (30 días)',
      cloudBooks: 'Libros en la nube',
      readingTime: 'Tiempo leído',
      aiTokens: 'Tokens IA',
      last90d: 'últimos 90 días',
      activityTitle: 'Actividad (últimos 30 días)',
      providerUsage: 'Uso de proveedores IA',
      requests: 'pet.',
      tokens: 'tokens',
    },
    users: {
      title: 'Usuarios',
      subtitle: '{n} usuario(s) registrados | {n} usuario registrado | {n} usuarios registrados',
      searchPlaceholder: 'Buscar por email…',
      colEmail: 'Email',
      colRole: 'Rol',
      colCreated: 'Registro',
      colLastSeen: 'Última actividad',
      colActions: 'Acciones',
      you: 'tú',
      bannedBadge: 'suspendido',
      empty: 'Sin resultados.',
      justNow: 'ahora mismo',
      minAgo: 'hace {n} min',
      hourAgo: 'hace {n} h',
      dayAgo: 'hace {n} d',
      actions: {
        promote: 'Promover a admin',
        demote: 'Quitar admin',
        ban: 'Suspender',
        unban: 'Reactivar',
        'promote.done': 'Usuario promovido a administrador.',
        'demote.done': 'Usuario degradado.',
        'ban.done': 'Usuario suspendido.',
        'unban.done': 'Usuario reactivado.',
      },
      confirm: {
        promote: { title: 'Promover a administrador', body: 'Este usuario podrá ver todos los datos y gestionar la app. ¿Confirmas?' },
        demote: { title: 'Quitar permisos de admin', body: 'El usuario dejará de tener acceso al panel de administración.' },
        ban: { title: 'Suspender usuario', body: 'El usuario no podrá iniciar sesión hasta que lo reactives.' },
        unban: { title: 'Reactivar usuario', body: 'El usuario podrá volver a iniciar sesión.' },
      },
    },
    events: {
      title: 'Eventos',
      subtitle: 'Feed de eventos para depuración y métricas.',
      filterType: 'Tipo',
      filterUser: 'Usuario (UUID)',
      allTypes: 'Todos los tipos',
      userUuidPlaceholder: 'UUID completo',
      colTime: 'Fecha',
      colType: 'Tipo',
      colUser: 'Usuario',
      colProps: 'Datos',
      empty: 'No hay eventos para estos filtros.',
      showing: 'Mostrando {n} evento(s).',
    },
    email: {
      title: 'Correo transaccional',
      subtitle: 'Integración con Resend para Auth y notificaciones.',
      statusTitle: 'Estado de la integración',
      smtpTransport: 'Auth SMTP (Supabase)',
      smtpHint: 'Configúralo en el dashboard de Supabase → Auth → SMTP',
      edgeFunction: 'Edge Function (Resend API)',
      noSupabase: 'Supabase no configurado en Ajustes',
      setupHint: 'Consulta la guía de configuración en',
      testTitle: 'Prueba de envío',
      recipient: 'Destinatario',
      sendTest: 'Enviar correo de prueba',
      testSent: 'Correo enviado (revisa la bandeja y el historial).',
      enterRecipient: 'Indica un email de destino.',
      configSyncFirst: 'Configura Supabase en Ajustes → Sincronización para activar el envío.',
      broadcastTitle: 'Broadcast a usuarios',
      broadcastHint: 'Envía una plantilla a todos los usuarios activos. Solo administradores.',
      broadcastTemplate: 'Plantilla',
      broadcastVars: 'Variables (JSON)',
      broadcastActiveDays: 'Solo activos en los últimos',
      broadcastDays: 'días (0 = todos)',
      sendBroadcast: 'Enviar broadcast',
      broadcastOk: 'Broadcast enviado a {n} destinatario(s).',
      broadcastPartial: 'Enviados: {ok}. Fallidos: {fail}. Revisa el historial.',
      broadcastResult: '✓ {sent} enviados · {failed} fallidos',
      invalidVars: 'El JSON de variables no es válido.',
      history: 'Historial de envíos',
      colWhen: 'Fecha',
      colTo: 'Para',
      colTemplate: 'Plantilla',
      colStatus: 'Estado',
      noLogs: 'Aún no se han enviado correos.',
    },
    audit: {
      title: 'Auditoría',
      subtitle: 'Registro de acciones de administración.',
      colWhen: 'Fecha',
      colActor: 'Actor',
      colAction: 'Acción',
      colTarget: 'Objetivo',
      colMeta: 'Detalle',
      empty: 'Sin acciones registradas.',
    },
    system: {
      title: 'Sistema',
      subtitle: 'Estado de la conexión a la base de datos (Supabase). Solo lectura.',
      host: 'Host del proyecto',
      credentialsSource: 'Credenciales',
      viaEnv: 'Inyectadas en el build (variables de entorno)',
      note: 'Las credenciales se configuran en el despliegue y no se muestran ni editan aquí. Esta vista solo informa del estado de la conexión.',
    },
  },
}
